import React from 'react'

function Dropdown(props) {
    let options = []
    for (const [value, option] of Object.entries(props.options)){
        options.push(<option key={value} value={value}>{option}</option>)
    }

    if (props.resetStyles) {
        return (
            <select 
                name={props.name} 
                className={props.class || ''} 
                id={props.id} 
                value={props.value !== undefined ? props.value : ''} 
                onChange={props.onChange}
            >
                {options}
            </select>
        )
    }

    return (
        <div className={`left input-field ${props.class}`}>
            <label className="input-field__label" >{props.label}</label>
            <select name={props.name} className="input-field__input" id={props.id} onChange={props.onChange}>
                {options}
            </select>
            <p className="error">{props.error}</p>
        </div>
    )
}

export default Dropdown